/* eslint-disable sort-keys */
import { Injectable, inject } from '@angular/core';
import { LoggerService } from '@app/services/logger.service';
import { ConfigService, CoreConfiguration } from '@rockwell-automation-inc/service';
import {
  CommandRequest,
  DomainEventName,
  DomainEvents,
  EventPredicate,
  IDomainUpdateRequestBuilderOptions,
} from './command-request.service';

@Injectable({
  providedIn: 'root',
})
export class CommandRequestBuilderService {
  private readonly configService = inject<ConfigService<CoreConfiguration>>(ConfigService);

  private readonly logger = inject(LoggerService).withContext(CommandRequestBuilderService);

  // TO DO: define retuning type
  new(
    apiPath: string,
    method: 'POST' | 'DELETE' | 'PUT' | 'PATCH',
    domainEvent: EventPredicate | DomainEventName | DomainEvents,
    options: IDomainUpdateRequestBuilderOptions = {} as IDomainUpdateRequestBuilderOptions,
  ): CommandRequest {
    const apiEndPoint = this.configService.config.csApiBaseUrl + apiPath;
    this.logger.log('creating CommandRequestService instance for:  ', apiEndPoint);
    return CommandRequest.create(apiEndPoint, method, domainEvent, options);
  }
}
